import KpiCard from '@components/kpi-card/kpi-card.tsx';
import KpiCardSkeleton from '@components/kpi-card/kpi-card-skeleton.tsx';
import MetricCard from '@components/metric-card/metric-card.tsx';
import MetricCardSkeleton from '@components/metric-card/metric-card-skeleton.tsx';
import revenueIcon from '@assets/icons/analytics/revenue.svg';
import completionRateIcon from '@assets/icons/analytics/completion-rate.svg';
import totalOrdersIcon from '@assets/icons/analytics/total-orders.svg';
import rejectedOrdersIcon from '@assets/icons/analytics/rejected-orders.svg';
import arrowUpIcon from '@assets/icons/home/arrow-up-green.svg';
import arrowDownIcon from '@assets/icons/home/arrow-down-red.svg';

const Block = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-3 w-full">
    <p className="font-semibold text-gray-700">{title}</p>
    <div className="flex gap-6">{children}</div>
  </div>
);

function CardsComponent() {
  return (
    <div className="flex flex-col gap-12">
      <h2 className="text-xl font-bold text-gray-800">Cards</h2>

      {/* ---------- KPI Card ---------- */}
      <div className="flex flex-col gap-6">
        <h3 className="text-lg font-bold text-gray-800">KPI Card</h3>

        <Block title="With trend / hidden trend">
          <KpiCard
            icon={revenueIcon}
            arrowIcon={arrowUpIcon}
            title="Total Revenue"
            value="$24,500"
            percent="+12.5%"
            percentTextColor="var(--teal-2)"
            background="var(--blue-gradient-1)"
          />
          <KpiCard
            icon={completionRateIcon}
            arrowIcon={arrowDownIcon}
            title="Occupancy"
            value="78%"
            percent="10%"
            percentTextColor="rgba(255, 1, 0, 1)"
            background="var(--orange-gradient-1)"
          />
        </Block>

        <Block title="Loading (skeleton)">
          <div className="flex flex-col justify-between w-full max-w-95.25 h-[190.5px] gap-0.5 p-[22px_28px_16px_28px] rounded-[13px] shadow-[0_4px_16px_0_rgba(0,0,0,0.1)] bg-white">
            <KpiCardSkeleton />
          </div>
        </Block>
      </div>

      {/* ---------- Metric Card ---------- */}
      <div className="flex flex-col gap-6">
        <h3 className="text-lg font-bold text-gray-800">Metric Card</h3>

        <Block title="With trend / hidden trend">
          <MetricCard
            icon={totalOrdersIcon}
            arrowIcon={arrowUpIcon}
            title="Orders Today"
            value="342"
            percent="+8.2%"
            percentTextColor="var(--teal-2)"
          />
          <MetricCard
            icon={rejectedOrdersIcon}
            arrowIcon={arrowDownIcon}
            title="Cancellations"
            value="12"
            percent="5%"
            percentTextColor="rgba(255, 1, 0, 1)"
          />
        </Block>

        <Block title="Loading (skeleton)">
          <div className="inline-flex w-1/2 h-27.5 flex-col bg-(--white) p-6 rounded-2xl shadow-[0_4px_16px_0_rgba(0,0,0,0.1)]">
            <MetricCardSkeleton />
          </div>
        </Block>
      </div>
    </div>
  );
}

export default CardsComponent;
